export default "__VITE_ASSET__p5ORvkee__"